(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[180,6723],{

/***/ 76723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CompareAction": function() { return /* binding */ CompareAction; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53990);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5434);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2804);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


var _excluded = ["referance", "referanceId", "is_compared"];













var CompareAction = function CompareAction(_ref) {
  var referance = _ref.referance,
      referanceId = _ref.referanceId,
      is_compared = _ref.is_compared,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_4__/* .authAtom */ .L4);
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_3__/* .useSystemActions */ .x3)();
  var authActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_3__/* .useAuthActions */ .X$)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, []); //Handle University Compare

  var handleUniCompare = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(universityId) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);

              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context2.next = 10;
                break;
              }

              if (!(profileInfo.compareUniversityList && !profileInfo.compareUniversityList.includes(parseInt(universityId)) && profileInfo.compareUniversityList.length >= 3)) {
                _context2.next = 6;
                break;
              }

              (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)("You can compare among a maximum of 3 universities", "Sorry!");
              setIsLoading(false);
              return _context2.abrupt("return", false);

            case 6:
              _context2.next = 8;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/compare-university", {
                universityId: universityId
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context.next = 6;
                            break;
                          }

                          _context.next = 3;
                          return authActions.getProfile();

                        case 3:
                          setIsLoading(false);
                          _context.next = 8;
                          break;

                        case 6:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 8:
              _context2.next = 19;
              break;

            case 10:
              if (!(profileInfo && profileInfo.userTypeSlug !== "student")) {
                _context2.next = 15;
                break;
              }

              setIsLoading(false);
              return _context2.abrupt("return");

            case 15:
              setIsLoading(false);
              systemActions.setReturnUrl(router.asPath);
              _context2.next = 19;
              return router.push({
                pathname: "/signin"
              });

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUniCompare(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); //course Compare


  var handleCourseCompare = /*#__PURE__*/function () {
    var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(courseId) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setIsLoading(true);

              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context4.next = 10;
                break;
              }

              if (!(profileInfo.compareCourseList && !profileInfo.compareCourseList.includes(parseInt(courseId)) && profileInfo.compareCourseList.length >= 3)) {
                _context4.next = 6;
                break;
              }

              (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)("You can compare among a maximum of 3 courses", "Sorry!");
              setIsLoading(false);
              return _context4.abrupt("return", false);

            case 6:
              _context4.next = 8;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/compare-course", {
                courseId: courseId
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context3.next = 6;
                            break;
                          }

                          _context3.next = 3;
                          return authActions.getProfile();

                        case 3:
                          setIsLoading(false);
                          _context3.next = 8;
                          break;

                        case 6:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 8:
              _context4.next = 19;
              break;

            case 10:
              if (!(profileInfo && profileInfo.userTypeSlug !== "student")) {
                _context4.next = 15;
                break;
              }

              setIsLoading(false);
              return _context4.abrupt("return");

            case 15:
              setIsLoading(false);
              systemActions.setReturnUrl(router.asPath);
              _context4.next = 19;
              return router.push({
                pathname: "/signin"
              });

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleCourseCompare(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var renderComponent = function renderComponent() {
    //for active
    if (is_compared == false) {
      if (referance && referance == "university" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdSwapCalls */ .mzl, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_swap)),
            onClick: function onClick() {
              return handleUniCompare(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), !profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Add to ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " compare"]
          })]
        });
      }

      if (referance && referance == "course" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdSwapCalls */ .mzl, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_swap)),
            onClick: function onClick() {
              return handleCourseCompare(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), !profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Add to ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " compare"]
          })]
        });
      }
    } //for inactive


    if (is_compared == true) {
      if (referance && referance == "university" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdSwapCalls */ .mzl, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_swap), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().selected)),
            onClick: function onClick() {
              return handleUniCompare(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Remove from ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " compare"]
          })]
        });
      }

      if (referance && referance == "course" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdSwapCalls */ .mzl, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_swap), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().selected)),
            onClick: function onClick() {
              return handleCourseCompare(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Remove from ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " compare"]
          })]
        });
      }
    }
  };

  if (true) {
    return renderComponent();
  } else {}
};
/* harmony default export */ __webpack_exports__["default"] = (CompareAction);

/***/ }),

/***/ 53913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favourite_wrapper":"actions_favourite_wrapper__mmZgl","icon_heart":"actions_icon_heart__MtTT3","selected":"actions_selected__bf0TV","icon_swap":"actions_icon_swap__irRwk","compare_wrapper":"actions_compare_wrapper__z_sdX","bookmarke_wrapper":"actions_bookmarke_wrapper__31rzO","btn_bookmark":"actions_btn_bookmark__pq8QI","active":"actions_active__vtMRT","icon_spin":"actions_icon_spin__z5nco","spin":"actions_spin__kUes6","connect_wrapper":"actions_connect_wrapper__ESCJU","reply_box_wrapper":"actions_reply_box_wrapper__AVnAn","reply_box_to":"actions_reply_box_to__rmbnD","reply_box_subject":"actions_reply_box_subject__CBp2A","reply_box_actions":"actions_reply_box_actions__GBlrl","reply_box_action_right":"actions_reply_box_action_right__4oLns"};

/***/ })

}]);